var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_4059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.5V13.5C14.75 14.051 14.303 14.5 13.75 14.5H3.75C3.19897 14.5 2.75 14.051 2.75 13.5V2.5H9.75L11.75 0.5H2.75C1.646 0.5 0.75 1.396 0.75 2.5V13.5C0.75 15.157 2.094 16.5 3.75 16.5H13.75C15.4079 16.5 16.75 15.157 16.75 13.5V5.5L14.75 7.5Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 12.263L8.96484 11.263L7.46484 9.76303L5.96484 8.26303L4.96484 12.263ZM6.75781 7.64209L9.58581 10.4711L16.5408 3.516C16.6498 3.408 16.7168 3.26703 16.7269 3.12209C16.7389 2.97906 16.6919 2.84706 16.598 2.75312L14.5528 0.709906L14.4749 0.632C14.3868 0.544 14.2677 0.5 14.1448 0.5C13.9947 0.5 13.8359 0.563031 13.7128 0.688L13.6907 0.710094L11.6888 2.71009L6.75781 7.64209Z",
    fill: "#FF5555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_4059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fbdb518076f798edb416c3f2730c0eae.svg";
export { ForwardRef as ReactComponent };